import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { withFaqPageSchema } from '../../builders/faq'
import { buildServiceSchema } from '../../builders/service'
import { pdmPmmFaqItems } from '../../data/faqs/pdm-pmm'
import { PageMeta } from '../../types'

const description =
  'PMMの導入をはじめ、GTM戦略・KPI設計・組織設計までを支援し、PdM/PMMの仕組みづくりや、継続的に市場に適応し事業が伸び続ける基盤づくりを伴走サポートします。'

export const pdmPmmPageMeta: PageMeta = {
  title: 'PdM/PMM体制実行支援 | サービス | i3DESIGN アイスリーデザイン',
  description,
  keyword: 'PMM PdM プロダクト マーケティング',
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/pdm-pmm/`,
}

const pdmPmmServiceSchema = buildServiceSchema({
  slug: 'pdm-pmm',
  name: 'PdM/PMM体制実行支援',
  description: pdmPmmPageMeta.description,
  serviceType: 'PdM/PMM体制実行支援',
  category: 'プロダクト成長支援',
  offerCatalogName: 'PdM/PMM体制実行支援サービス',
  breadcrumbName: 'PdM/PMM体制実行支援',
  offers: [
    {
      name: 'プロダクト戦略策定',
      description:
        'PdMとPMM、それぞれの視点から戦略構築をサポートし、「つくる」と「売る」が一体となった成長戦略を設計します。',
    },
    {
      name: '組織設計・育成',
      description:
        'PdM/PMMの役割整理にとどまらず、UXデザイナーやマーケターを含む関連人材の連携設計や育成も支援します。',
    },
    {
      name: 'ハンズオン',
      description:
        '伴走パートナーとして、戦略だけでなく実行レベルの支援も提供。現場で動く施策の企画・レビュー・改善までを共に進めます。',
    },
  ],
})

export const pdmPmmSchema = withFaqPageSchema(pdmPmmServiceSchema, pdmPmmPageMeta.url, pdmPmmFaqItems)
